import { render } from "./transactionReport.vue?vue&type=template&id=6b2d620c"
import script from "./transactionReport.vue?vue&type=script&lang=js"
export * from "./transactionReport.vue?vue&type=script&lang=js"

import "./transactionReport.vue?vue&type=style&index=0&id=6b2d620c&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__